import CheckOrderInputContainer from "@CheckOrder/components/MainSection/CheckOrderInputContainer";
import DropdownButton from "@Generic/buttons/DropdownButton";
import React from "react";
import {VehicleAddonResponseType} from "@CheckOrder/api/types/GetAddonData.type";
import VehicleTypeOption
    from "@CheckOrder/features/addons/features/jadrolinija/features/vehicleType/components/VehicleTypeOption";
import useGetSelectedVehicleTypeLabel
    from "@CheckOrder/features/addons/features/jadrolinija/features/vehicleType/hooks/useGetSelectedVehicleTypeLabel";
import Translation from "@Translation/components/Translation";

interface VehicleTypeProps {
    selectOptions: { value: number, label: string, activeGroup: VehicleAddonResponseType }[],
    activeOption: { value: number, label: string, activeGroup: VehicleAddonResponseType },
    setVehicleType: (value) => void,
}

function VehicleType({selectOptions, activeOption, setVehicleType}: VehicleTypeProps) {
    const {getActiveLabel} = useGetSelectedVehicleTypeLabel(selectOptions, activeOption)

    return (
        <CheckOrderInputContainer
            label={(<Translation translationKey="check_order.addons.JADL.vehicle.type.title"/>)}
            className="vehicle__type-select"
        >
            <DropdownButton
                label={getActiveLabel()}
                baseClass="gb--select"
                cssButtonClass="gb--select-dropdown"
            >
                {selectOptions.map((option) => (
                    <VehicleTypeOption
                        option={option}
                        setVehicleType={setVehicleType}
                    />
                ))}
            </DropdownButton>
        </CheckOrderInputContainer>
    )
}

export default VehicleType